const menuImage = (props) => {
  return props.img.image;
};

export default menuImage;
